<div class="cntr bg-[url(assets/img/bg2.jpg)]">
    <div class="box">
        <div class="logo">
            <img src="assets/img/anytrack_logo.svg" />
        </div>
        <div class="txt">
            <h1>{{cargoName}}</h1>
            <p>Пожалуйста войдите в систему для продолжения работы</p>
        </div>
    </div>
</div>